import React from 'react'

// Context
import AuthContext from './AuthContext'

export default (
  propName: string = 'auth'
) => (
  WrappedComponent: React.ComponentType
): any => class NavigationContainer extends React.Component {

  render() {
    return (
      <AuthContext.Consumer>
        {context => (
          <WrappedComponent
            {...this.props}
            {...{[propName]: context}}
          />
        )}
      </AuthContext.Consumer>
    )
  }

}
